import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import AuthMixin from '@/mixins/AuthMixin.vue'

@Component
export default class QuantityTypeSelector extends Mixins(AuthMixin) {
  @Prop({type: String, default: ''})
  public selectedCategory!: string

  @Prop({type: String, default: ''})
  public selectedQuantityType!: string

  @Prop({type: String, default: 'See order comments'})
  public commentOption!: string

  private _quantityType = ''

  public static beerTypes = [
    '6 pack',
    '12 pack',
    'Case (18oz 15 pack)',
    'Case (500mL 20 pack)',
    'Case (12oz 24 pack)',
    'Case (16oz 24 pack)',
    'Keg (5.16 gallon)',
    'Keg (5.2 gallon)',
    'Keg (7.75 gallon)',
    'Keg (15.5 gallon)'
  ]
  public static liquorTypes = [
    '750mL',
    'Liter',
    '1.75L',
    'Case - 6',
    'Case - 12'
  ]
  public static wineTypes = [
    '750mL',
    'Liter',
    'Case - 6',
    'Case - 12'
  ]
  public static bittersAndCocktailMixTypes = [
    'Case - 6',
    'Case - 12'
  ]
  public static waterTypes = [
    '500 ml',
    '750 ml',
    'Case (500mL)',
    'Case (750mL)'
  ]

  public static resolveQuantityType(types: string[], text: string): string {
    if (!text || !types || !types.length) {
      return ''
    }
    return types.filter(t => {
        const normalizedText = text.toUpperCase().replaceAll(' ', '')
        const normalizedType = t.toUpperCase()
        return text.includes(t) || normalizedText.includes(normalizedType)
      }
    ).pop()
  }

  public set quantityType(quantityType: string) {
    this._quantityType = quantityType
    this.updateQuantityTypeSelection(quantityType)
  }

  public get quantityType() {
    return this._quantityType || this.selectedQuantityType
  }

  public get quantityTypes() {
    if (!this.selectedCategory) {
      return [this.commentOption]
    }

    return QuantityTypeSelector.resolveQuantityTypesByCategory(this.selectedCategory)
  }

  public static resolveQuantityTypesByCategory(category: string): string[] {
    if (!category) {
      return []
    }
    if (category === 'Food, Beverages & Tobacco > Beverages > Alcoholic Beverages > Beer') {
      return QuantityTypeSelector.beerTypes
    } else if (category.includes('Liquor & Spirits')) {
      return QuantityTypeSelector.liquorTypes
    } else if (category.includes('Wine')) {
      return QuantityTypeSelector.wineTypes
    } else if (category.includes('Bitters')) {
      return QuantityTypeSelector.bittersAndCocktailMixTypes
    } else if (category.includes('Cocktail Mixes')) {
      return QuantityTypeSelector.bittersAndCocktailMixTypes
    } else if (category.includes('Hard Cider')) {
      return QuantityTypeSelector.beerTypes
    } else if (category.includes('Flavored Alcoholic Beverages')) {
      return QuantityTypeSelector.beerTypes
    } else if (category.includes('Water')) {
      return QuantityTypeSelector.waterTypes
    } else {
      return []
    }
  }

  public beforeMount() {
    if (!QuantityTypeSelector.beerTypes.includes(this.commentOption)) {
      QuantityTypeSelector.beerTypes.push(this.commentOption)
    }
    if (!QuantityTypeSelector.bittersAndCocktailMixTypes.includes(this.commentOption)) {
      QuantityTypeSelector.bittersAndCocktailMixTypes.push(this.commentOption)
    }
    if (!QuantityTypeSelector.liquorTypes.includes(this.commentOption)) {
      QuantityTypeSelector.liquorTypes.push(this.commentOption)
    }
    if (!QuantityTypeSelector.waterTypes.includes(this.commentOption)) {
      QuantityTypeSelector.waterTypes.push(this.commentOption)
    }
    if (!QuantityTypeSelector.wineTypes.includes(this.commentOption)) {
      QuantityTypeSelector.wineTypes.push(this.commentOption)
    }
  }

  @Emit('updateQuantityTypeSelection')
  public async updateQuantityTypeSelection(quantityType: string) {
    return quantityType
  }
}
